import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import "./transitModal.scss";
import { useNavigate } from "react-router-dom";
import { TRANSIT_EDIT } from "../../constants/routers";
import DataTable from "react-data-table-component";
import { transitHistoryFetch } from "../../api/actions/transitform";
import toast from "react-hot-toast";
import { Tooltip } from "@mui/material";

const TransitModal = ({
  setTransitHistory,
  show,
  handleClose,
  museumObjectId,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [order, setOrder] = useState("desc");
  const [sort, setSort] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const commonPath = userData.museum_name
    ? userData?.museum_name?.split(" ").join("_")
    : "Nefos";

  const fetchTransitHistory = (pageNumber) => {
    if (!museumObjectId) return;
    setLoading(true);

    transitHistoryFetch({
      page: pageNumber,
      limit: 25,
      museum_object: museumObjectId,
      order: order,
      sort_by: sort,
    })((response) => {
      setLoading(false);
      if (response?.status) {
        const newResults = response.data.results || [];
        const count = response.data.count || 0;

        setData((prevData) => {
          const updated =
            pageNumber === 1 ? newResults : [...prevData, ...newResults];
          setTotalCount(count);
          setHasMore(updated.length < count); // ✅ use updated data length
          return updated;
        });
      } else {
        toast.error(response?.message || "Failed to load transit history");
      }
    });
  };

  const sortHandler = (column, direction) => {
    setOrder(direction);
    setSort(column.key);
    setPage(1);
  };

  useEffect(() => {
    if (show) {
      fetchTransitHistory(1);
    }
  }, [sort, order]);

  useEffect(() => {
    if (show) {
      setPage(1);
      setData([]);
      fetchTransitHistory(1);
    }
  }, [show]);

  useEffect(() => {
    const container = document.querySelector(".my-data-table");

    const handleScroll = () => {
      if (!hasMore || loading) return;

      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 20
      ) {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchTransitHistory(nextPage);
      }
    };

    if (container) container.addEventListener("scroll", handleScroll);
    return () =>
      container && container.removeEventListener("scroll", handleScroll);
  }, [page, hasMore, loading]);

  const redirectToTransitDetail = (tranitDetail) => {
    navigate(`/${commonPath}/${TRANSIT_EDIT}/${tranitDetail?.transit_form}`, {
      state: { fromDetail: true, objectId: museumObjectId },
    });
  };

  const columns = [
    {
      name: "Transit form",
      key: "transit_form_transit_number",
      selector: (row) => row?.transit_form_number,
      cell: (row) => (
        <Tooltip title="Click for the detail">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => redirectToTransitDetail(row)}
          >
            <p>{row?.transit_form_number}</p>
          </div>
        </Tooltip>
      ),
      width: "200px",
      sortable: true,
    },
    {
      name: "Old location",
      key: "old_locationroom_number",
      selector: (row) => row?.old_location_room_number,
      cell: (row) => {
        return (
          <div>
            <p>{`${row?.old_location_room_number} (${row?.old_location_code})`}</p>
          </div>
        );
      },
      width: "260px",
      sortable: true,
    },
    {
      name: "New location",
      key: "new_location_room_number",
      selector: (row) => row?.material_name,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          <p>{`${row?.new_location_room_number} (${row?.new_location_code})`}</p>
        </div>
      ),
      width: "260px",
      sortable: true,
    },
    {
      name: "Transit date",
      key: "id",
      selector: (row) => row?.transit_date,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          <p>{row?.transit_date}</p>
        </div>
      ),
      width: "260px",
      sortable: true,
    },
  ];

  return (
    <Modal
      show={show}
      centered
      onHide={handleClose}
      dialogClassName="content-based-modal"
    >
      <div className="notification-modal">
        <Modal.Header className="detail-view-header" closeButton>
          <Modal.Title>Transit location history</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="dataTable-wrapper">
            <div className="table-wrapp">
              <DataTable
                sortServer
                onSort={sortHandler}
                className="my-data-table"
                columns={columns}
                data={data}
                striped
                highlightOnHover
                fixedHeader
                fixedHeaderScrollHeight="50vh"
                progressPending={loading}
                progressComponent={
                  <div style={{ padding: "10px", textAlign: "center" }}>
                    <Spinner animation="border" />
                  </div>
                }
                noHeader
              />
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default TransitModal;
